import { useEffect, useState } from 'react';
import { hotelEngineService } from '@/api/services';
import { hotelEngineClosedMessage, isHotelEngineSellable } from '@/utils/hotelEngineSell';

export default function useHotelEngineSell() {
  const [status, setStatus] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    hotelEngineService
      .getStatus()
      .then((res) => {
        if (cancelled) return;
        setStatus(res?.data?.data || res?.data || null);
      })
      .catch(() => {
        if (!cancelled) setStatus(null);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return {
    status,
    loading,
    sellable: isHotelEngineSellable(status),
    message: hotelEngineClosedMessage(status),
  };
}
